"use client"
import { useState, useEffect } from "react";
import AboutTab from "@/components/sections/about-tab";
import { usePathname } from "next/navigation";
import Link from "next/link";
import { cn } from "@/lib/utils";
import WordsFormOurLeaders from "./_components/words-form-our-leaders";
import Accreditation from "./_components/accreditation";
import Image from "next/image";
import HowToSeries from "./_components/how-to-series";

export default function About() {


    const siliconValleyHighlights = [
        {
            title: "IT Companies: 3km radius",
            value: "300+",
        },
        {
            title: "Business",
            value: "500+",
        },
        {
            title: "International Outsourcing Companies",
            value: "20+",
        },
    ];

    return (
        <article
            className={`xl:block pt-0 float-left w-full clear-both bg-white`}
        >
            <header
                className={`bg-[url('/about.webp')] bg-[#146ba9] 
                    bg-blend-multiply xl:sticky xl:top-[-10.9375rem] 
                    md:sticky md:top-[-9.875rem] 
                    float-left w-full clear-both 
                    bg-center bg-no-repeat bg-cover bottom-0 h-[17.1875rem]
                     left-0 sticky right-0 z-[99]`}
            >
                <div
                    className={`text-center pt-[6.25rem] mb-[5.9375rem] z-[1] relative align-middle`}
                >
                    <h1 className={cn(
                        // `xl:text-[4rem] md:text-[3.25rem] text-white inline`,
                        `xl:text-[3rem] md:text-[2.25rem] text-white inline`,
                        `xl:leading-[5rem] `,
                        `md:leading-[4.375rem] md:clear-none`,
                        `text-[1.125rem] leading-[2.75rem] mt-0 clear-both font-bold`
                    )}>
                        About Pcps
                    </h1>
                </div>

                <AboutTab />

            </header>

            <div
                className={cn(
                    // `xl:p-[0_5rem] md:p-[0_3.125rem] w-full max-w-[90rem] clear-both m-[0_auto_2rem]`,
                    `2xl:p-[0_5rem] xl:p-[0_5rem] md:p-[0_3.125rem]`,
                    `w-full max-w-[90rem] p-[0_1.25rem]
                clear-both m-[0_auto_2rem]
                `,

                    /* `before:transform before:translate-x-[-50%] before:translate-y-[5.875rem]
                    before:md:w-[12.5rem] before:md:h-[9.8125rem] before:md:mb-[-9.8125rem] 
                    before:mx-auto before:sticky before:top-[6.25rem] before:pointer-events-none 
                    before:left-1/2 before:block before:bg-[url('/logo.png')] 
                    before:bg-no-repeat before:bg-contain
                    before:opacity-[.125] before:transition-[opacity_0.15s_ease]` */
                    `before:transform before:translate-x-[-50%] before:translate-y-[5.875rem]

                before:md:w-[12.5rem] before:md:h-[9.8125rem] before:md:mb-[-9.8125rem] 

                before:w-[8.625rem] before:h-[6.75rem] before:mb-[-6.75rem]
                before:mx-auto before:sticky before:top-[6.25rem] before:pointer-events-none 
                before:left-1/2 before:block 
                 before:bg-[url('/logo.png')] 
                before:bg-no-repeat before:bg-contain
                before:opacity-[.125] before:transition-[opacity_0.15s_ease]`
                )}
            >
                <div className={`xl:mt-[7.0625rem] md:mt-[5.8125rem] mt-[3.9375rem] `}>
                    <div
                        className={`p-0 xl:mb-[4.3125rem] w-full max-w-[90rem] m-[0_auto] clear-both block`}
                    >
                        <h2
                            className={cn(
                                `xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] 
                        md:mx-auto md:w-full [word-wrap:break-word] xl:text-[1.875rem] 
                        xl:leading-[2.5rem] md:text-[1.625rem] md:leading-[2.1875rem] md:mb-4 
                        md:clear-none 
                        mt-0 mb-[0.375rem] text-[1.25rem] leading-[1.6875rem] clear-both font-bold`
                            )}
                        >
                            Why Pcps College?
                        </h2>


                        {/*    <figure
                            className={`xl:m-[0.5625rem_1.875rem_2.5rem_3.9375rem] xl:max-w-[20.625rem] md:float-left
                                 md:m-[1.5625rem_2rem_1.9375rem_0] md:max-w-[16.75rem]
                table m-[1.5625rem_0] relative w-full clear-left`}
                        >
                            <div
                                className={`bg-[url('/1764222660_IMG_6070.jpeg')] xl:size-[20.625rem] 
                                    xl:max-h-[20.625rem] md:max-h-[16.75rem] 
                  bg-no-repeat bg-contain h-[87.5vw] max-h-[25rem] w-full`}
                            />
                            <div
                                className={cn(
                                    `bg-[url('/pcpsbg.jpg')] xl:size-[22.625rem] 
                                      xl:max-h-[22.625rem] md:max-h-[24.625rem] 
                    bg-no-repeat bg-contain h-[87.5vw] max-h-[25rem] w-full`,
                                )}
                                className={cn(
                                    `bg-[url('/pcpsbg.jpg')] xl:w-[22.625rem] z-10
                                    
                  bg-no-repeat bg-contain h-[16.5vw] w-full `,
                                    `after:absolute after:inset-0 after:z-[0]
                  after:bg-[url('/svgs/dot-black.svg')] after:bg-[length:0.1875rem] 
                  after:[transform:translate(1.625rem,0.625rem)] after:[transition:all_0.35s_ease-out] after:ease-out`,
                                    `xl:max-h-[22.625rem] md:max-h-[24.625rem] `
                                )}

                                className={cn(
                                    `
                                        relative
                                        bg-[url('/pcpsbg.jpg')]
                                        bg-no-repeat bg-contain
                                        xl:w-[22.625rem]
                                        h-[16.5vw] w-full
                                        z-10
                                        `,
                                    `
                                        after:content-['']
                                        after:absolute
                                        after:inset-0
                                        after:-z-10
                                        after:bg-[url('/svgs/dot-black.svg')]
                                        after:bg-[length:0.1875rem]
                                        after:translate-x-[1.625rem]
                                        after:translate-y-[0.625rem]
                                        after:opacity-60
                                        after:transition-all
                                        after:duration-300
                                        `
                                )}
                            />
                        </figure> */}

                        <figure
                            className={cn(
                                `xl:m-[0.5625rem_1.875rem_2.5rem_3.9375rem] xl:max-w-[20.625rem] md:float-left`,
                                `md:m-[1.5625rem_2rem_1.9375rem_0] md:max-w-[16.75rem]`,
                                `table m-[1.5625rem_0] relative w-full clear-left`
                            )}
                        >
                            <div
                                className="absolute inset-0 z-10 pointer-events-none
                                           bg-[url('/svgs/dot-black.svg')]
                                           bg-[length:0.1875rem] bg-repeat
                                           
                                           translate-x-[-1rem] translate-y-[.5rem]
                                           w-[11rem] md:w-full xl:max-h-[15.875rem]
                                           md:max-h-[24.625rem] max-h-[25rem]"
                                aria-hidden="true"
                            />
                            <div
                                className="relative z-10
                                           bg-[url('/pcpsbg.jpg')] bg-no-repeat bg-contain
                                           xl:w-[22.625rem] h-[32.5vw] w-full xl:max-h-[15.875rem]
                                           md:max-h-[24.625rem] max-h-[25rem]"
                                role="img"
                                aria-label="pcps"
                            />
                        </figure>

                        {/*  <figure
                            className={cn(
                                `xl:m-[0.5625rem_1.875rem_2.5rem_3.9375rem] xl:max-w-[20.625rem] md:float-left`,
                                `md:m-[1.5625rem_2rem_1.9375rem_0] md:max-w-[16.75rem]`,
                                `table m-[1.5625rem_0] relative w-full clear-left`
                            )}
                        >
                            <iframe
                                width="560"
                                height="315"
                                src="https://www.youtube.com/embed/s1p04zNRzGI?si=FGjMdoG2YfHQatIM"
                                title="YouTube video player"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            />
                        </figure> */}

                        {/* <figure
                            className="
    relative z-0 overflow-visible
    xl:m-[0.5625rem_1.875rem_2.5rem_3.9375rem]
    xl:max-w-[20.625rem]
    md:float-left md:m-[1.5625rem_2rem_1.9375rem_0]
    md:max-w-[16.75rem]
    table m-[1.5625rem_0] w-full clear-left
  "
                        >
                            <div
                                className="
      absolute inset-0
      translate-x-[-1rem]
      translate-y-[1rem]
      bg-[url('/svgs/dot-black.svg')]
      bg-[length:0.1875rem]
      opacity-60
      z-0
      pointer-events-none
      md:w-full
      w-[11rem]
      md:max-h-[11.875rem]
    "
                            />

                            <div
                                className="
      relative z-10
      bg-[url('/pcpsbg.jpg')]
      bg-no-repeat bg-contain
      xl:w-[22.625rem]
      h-[32.5vw] w-full
      xl:max-h-[15.875rem]
    "
                            />
                        </figure> */}


                        {[
                            `PCPS College, also known as Patan College for Professional Studies, is Nepal’s most career-focused UK degree institution and is proudly part of the Lord Buddha Education Foundation, Nepal’s pioneering IT institution since 1998. We offer internationally recognised UK undergraduate programmes in IT, Business, Business Analytics, and Digital Marketing. Our dynamic curriculum is designed to deliver academic excellence through a practical learning pedagogy, while our industry collaborations help students secure meaningful career opportunities.`
                        ].map((text) => {
                            return (
                                <p
                                    key={
                                        text
                                            .toLowerCase()
                                            .replace(/\s+/g, '-')
                                    }
                                    className={`xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] md:mx-auto md:w-full break-words xl:pt-[0.0625rem] md:clear-none clear-both
                xl:mb-[1.5rem] md:mb-[1.9375rem] md:text-base md:leading-8 mt-0
                `}
                                >
                                    {text}
                                </p>
                            );
                        })}
                        {/*  <p
                            className={`xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] md:mx-auto md:w-full break-words xl:pt-[0.0625rem] md:clear-none clear-both
                xl:mb-[1.5rem] md:mb-[1.9375rem] md:text-base md:leading-8 mt-0
                `}
                        >
                            As Pcps College, we’re bringing together today’s brightest minds to invent
                            the future for all of us. Join us.
                        </p> */}
                    </div>

                    <div
                        /*  className={`xl:float-none xl:m-[1.5rem_auto_5rem] xl:pb-0 md:clear-both md:float-none md:m-[1.875rem_0] 
               max-w-[95%] w-[53.6875rem] p-[4.125rem_2.3125rem_3.5rem_2.375rem] relative box-border
               before:absolute before:bottom-0 before:h-[calc(100%_-_2.5rem)] before:left-0 before:w-full before:z-[0] mb-12
               `} */
                        className={`xl:float-none xl:m-[1.5rem_auto_5rem] md:clear-both md:float-none md:m-[1.875rem_auto] 
                max-w-[95%] w-[53.6875rem] p-[4.125rem_2.3125rem_3.5rem_2.375rem] relative box-border
                before:absolute before:bottom-0 before:h-[calc(100%_-_2.5rem)] before:left-0 before:w-full before:z-[0] mb-12
                flex items-center justify-center
                `}
                    >
                        <div
                            className={`opacity-[1] transform translate-x-0 absolute top-auto bottom-0 h-[calc(100%_-_2.5rem)] w-[1.875rem] transition-[all_1s_ease]
                left-0 z-0 before:w-[0.0625rem] before:h-full before:absolute before:left-0 before:bg-[#E6054E] 
                `}
                        >
                            <svg
                                className="top-0 left-[-0.3125rem] absolute size-[2.1875rem] fill-[#E6054E]"
                                data-position="top_left"
                            >
                                <rect x="0" y="0" width="10" height="35"></rect>
                                <rect x="0" y="0" width="35" height="10"></rect>
                            </svg>

                            <svg
                                className="bottom-0 left-[-0.3125rem] absolute size-[2.1875rem] fill-[#E6054E]"
                                data-position="bot_left"
                            >
                                <rect x="0" y="0" width="10" height="35"></rect>
                                <rect x="0" y="25" width="35" height="10"></rect>
                            </svg>
                        </div>

                        <div
                            className={`opacity-[1] transform translate-x-0 absolute right-0 left-auto top-auto bottom-0 h-[calc(100%_-_2.5rem)] w-[1.875rem] transition-[all_1s_ease]
              z-0 before:w-[0.0625rem] before:h-full before:absolute before:bg-[#E6054E]
              before:right-0 before:left-auto before:[#EC0044]
                `}
                        >
                            <svg
                                className="top-0 right-[-0.3125rem] absolute size-[2.1875rem] fill-[#E6054E]"
                                data-position="top_right"
                            >
                                <rect x="25" y="0" width="10" height="35"></rect>
                                <rect x="0" y="0" width="35" height="10"></rect>
                            </svg>
                            <svg
                                className="bottom-0 right-[-0.3125rem] absolute size-[2.1875rem] fill-[#E6054E]"
                                data-position="bot_right"
                            >
                                <rect x="25" y="0" width="10" height="35"></rect>
                                <rect x="0" y="25" width="35" height="10"></rect>
                            </svg>
                        </div>

                        {/*  <p
                            className={`xl:text-[1.6875rem] xl:leading-[2.625rem] xl:m-[0.8125rem_3.4375rem_0] xl:pb-[2.875rem]
                md:mt-[0.8125rem] md:pb-[1.25rem] md:text-[1.125rem] max-w-[43.125rem] w-full relative z-0 italic
                text-center`}
                        >
                            The most career focused Uk degree in Nepal
                        </p> */}
                        <div className="flex justify-center items-center w-full">
                            <p
                                /* className={`xl:text-[2.25rem] xl:leading-[3.25rem] xl:m-[0.8125rem_0_0] xl:pb-[3.375rem]
                    md:mt-[0.8125rem] md:pb-[1.5rem] md:text-[1.5rem] max-w-[48.125rem] w-full relative z-0
                    text-center`} */
                                className={`xl:text-[2.25rem] xl:leading-[3.25rem] xl:m-[0.8125rem_0_0]
                         md:text-[1.5rem] max-w-[48.125rem] w-full relative z-0
                        text-center`}
                            >
                                &#8220;The most career focused Uk degree in Nepal&#8221;
                                {/* &#10077;The most career focused Uk degree in Nepal&#10078; */}
                            </p>
                        </div>
                    </div>

                    {/*   <figure
                        className={`xl:m-[0_auto_3.5rem] xl:p-0 xl:w-[54.375rem] md:float-none mb-[3.5rem] max-w-[90rem] clear-both relative w-full m-[0_auto] p-[0_1.25rem] float-left
             after:table after:clear-both
             `}
                        className={`xl:m-[0_auto_3.5rem] xl:p-0 xl:w-[54.375rem] md:float-none mb-[3.5rem] max-w-[90rem] clear-both relative w-full m-[0_auto] p-[0_1.25rem] float-left
                after:table after:clear-both
                `}
                    >
                        <div className={`overflow-hidden pt-[56.25%] relative`}>
                            <video
                                className={`border-[0] h-full left-0 absolute top-0 w-full object-contain`}
                                src={'/videos/NON_CREDIT_CC_V8_B.mp4'}
                                autoPlay
                                loop
                                muted
                                playsInline
                                controls={true}
                                poster="/pcpsbg.jpg"
                            />
                        </div>
                    </figure> */}
                    <figure
                        className={`xl:m-[0_auto_3.5rem] xl:p-0 xl:w-[54.375rem] md:float-none mb-[3.5rem] max-w-[90rem] clear-both relative w-full m-[0_auto] p-[0_1.25rem] float-left
            after:table after:clear-both
            `}
                    >
                        <div className={`overflow-hidden pt-[56.25%] relative`}>
                            <iframe
                                className={`border-[0] h-full left-0 absolute top-0 w-full`}
                                /* width="560"
                                height="315" */
                                 src="https://www.youtube.com/embed/s1p04zNRzGI?si=FGjMdoG2YfHQatIM"
                                title="Pcps college"
                                // playback="true"
                                // frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            // referrerpolicy="strict-origin-when-cross-origin"
                            // allowfullscreen="true"
                            />
                        </div>
                    </figure>


                    <div
                        /* className={`xl:float-none xl:m-[2.5rem_auto_5rem] xl:pb-0 md:clear-both md:float-none md:m-[1.875rem_0] 
              max-w-[95%] w-[53.6875rem] p-[5.125rem_2.3125rem_2.5rem_2.375rem] relative box-border
              before:absolute before:bottom-0 before:h-[calc(100%_-_2.5rem)] before:left-0 before:w-full before:z-[0]
              `} */
                        className={`xl:float-none xl:m-[2.5rem_auto_5rem]  md:clear-both md:float-none md:m-[1.875rem_0] 
                max-w-[95%] w-[53.6875rem] p-[5.125rem_2.3125rem_2.5rem_2.375rem] relative box-border
                before:absolute before:bottom-0 before:h-[calc(100%_-_2.5rem)] before:left-0 before:w-full before:z-[0]
                `}
                    >
                        <div
                            className={`opacity-[1] transform translate-x-0 absolute top-auto bottom-0 h-[calc(100%_-_2.5rem)] w-[1.875rem] transition-[all_1s_ease]
                left-0 z-0 before:w-[0.0625rem] before:h-full before:absolute before:left-0 before:bg-[#E6054E] 
                `}
                        >
                            <svg
                                className="top-0 left-[-0.3125rem] absolute size-[2.1875rem] fill-[#E6054E]"
                                data-position="top_left"
                            >
                                <rect x="0" y="0" width="10" height="35"></rect>
                                <rect x="0" y="0" width="35" height="10"></rect>
                            </svg>

                            <svg
                                className="bottom-0 left-[-0.3125rem] absolute size-[2.1875rem] fill-[#E6054E]"
                                data-position="bot_left"
                            >
                                <rect x="0" y="0" width="10" height="35"></rect>
                                <rect x="0" y="25" width="35" height="10"></rect>
                            </svg>
                        </div>

                        <div
                            className={`opacity-[1] transform translate-x-0 absolute right-0 left-auto top-auto bottom-0 h-[calc(100%_-_2.5rem)] w-[1.875rem] transition-[all_1s_ease]
              z-0 before:w-[0.0625rem] before:h-full before:absolute before:bg-[#E6054E]
              before:right-0 before:left-auto before:[#EC0044]
                `}
                        >
                            <svg
                                className="top-0 right-[-0.3125rem] absolute size-[2.1875rem] fill-[#E6054E]"
                                data-position="top_right"
                            >
                                <rect x="25" y="0" width="10" height="35"></rect>
                                <rect x="0" y="0" width="35" height="10"></rect>
                            </svg>
                            <svg
                                className="bottom-0 right-[-0.3125rem] absolute size-[2.1875rem] fill-[#E6054E]"
                                data-position="bot_right"
                            >
                                <rect x="25" y="0" width="10" height="35"></rect>
                                <rect x="0" y="25" width="35" height="10"></rect>
                            </svg>
                        </div>

                        {/*  <p
                            className={`xl:text-[1.6875rem] xl:leading-[2.625rem] xl:m-[0.8125rem_3.4375rem_0] xl:pb-[2.875rem]
                md:mt-[0.8125rem] md:pb-[1.25rem] md:text-[1.125rem] max-w-[43.125rem] w-full relative z-0 italic
                text-center`}
                        >
                            The most career focused Uk degree in Nepal
                        </p> */}
                        <div className="flex justify-center w-full">
                            <p
                                className={`xl:text-[2.25rem] xl:leading-[3.25rem] xl:m-[0.8125rem_0_0] xl:pb-[3.375rem]
                    md:mt-[0.8125rem] md:pb-[1.5rem] md:text-[1.5rem] max-w-[48.125rem] w-full relative z-0
                    text-center`}
                            >
                                &#8220;Transforming students with potential to amazing professionals&#8221;
                                {/* &#10077;The most career focused Uk degree in Nepal&#10078; */}
                            </p>
                        </div>
                    </div>


                    <Accreditation />
                    {/* <section
                        className={`xl:float-none clear-both float-[inherit] xl:m-[2.5rem_auto_5rem] xl:min-h-[20rem] md:mb-[3.25rem] md:m-[1.875rem_0] md:overflow-x-hidden 
              md:min-h-[9.375rem] float-[inherit] w-full m-[1.5625rem_0] overflow-x-scroll pb-[4.0625rem] relative z-0
              before:bg-[rgba(16,63,130,0.05)] before:absolute before:z-0 before:h-auto before:top-[17.54vw] before:bottom-0 before:left-0 
              before:pointer-events-none before:w-full
              `}
                    >
                        <header
                            className={`xl:w-[3.125rem] w-[2.1875rem] border-b border-b-[#272727]
                 block absolute top-0 left-0 [writing-mode:vertical-lr]`}
                            style={{
                                transform: "scale(-1)",
                            }}
                        >
                            <h2
                                className={`text-[0.75rem] xl:tracking-[0.125rem] 
                  futura-medium uppercase pb-[1.125rem] 
                  m-0 table-cell align-top whitespace-nowrap leading-[1]`}
                            >
                                Official Recognition & Accreditation
                            </h2>
                        </header>
                        <div
                            className={`max-w-[65.625rem] md:flex md:justify-between md:p-0 md:w-[87.5%] items-baseline box-border m-auto relative`}
                        >
                            {accreditationItems.map((item) => {
                                return (
                                    <Link
                                        href={"#"}
                                        title={item.label}
                                        className={`xl:placeholder:basis-[20.625rem] xl:mr-[1.875rem] xl:max-w-full
                      md:basis-[13.25rem] md:mr-[1.0625rem] inline-block basis-[14.5rem] m-[0_0_auto] [text-decoration:none]
                      w-[14.5rem] z-[1]
                      `}
                                    >
                                        <picture>
                                            <img
                                                src={item.image}
                                                alt={item.label}
                                                width="330"
                                                height="408"
                                                className={`md:mb-[1rem] md:h-fit h-fit mb-[0.9375rem] block max-w-full`}
                                            />
                                        </picture>
                                        <span
                                            className={`xl:both xl:text-[0.875rem] xl:leading-[1.125rem] 
                        xl:m-[0_0_0.6875rem] md:mb-[0.5625rem] futura-medium block 
                        tracking-[0.125rem] uppercase`}
                                        >
                                            <strong className="futura-medium">{item.label}</strong>
                                        </span>
                                        <span
                                            className={`xl:text-[1.375rem] xl:leading-[2rem] md:leading-[1.625rem] futura-heavy cursor-pointer
                        m-0 transition-[color_0.35s_ease-out] 
                        `}
                                            style={{
                                                backgroundImage:
                                                    "linear-gradient(to top,transparent 0.1875rem,#A31F34 0.1875rem,#A31F34 0.3125rem,transparent 0.3125rem)",
                                            }}
                                        >
                                            {item.description}
                                        </span>
                                    </Link>
                                );
                            })}
                        </div>
                    </section> */}

                    {/*   <section
                        className={`xl:float-none xl:m-[40px_auto_80px] md:m-[30px_0] xl:box-content md:px-[58px]
              md:max-w-[690px] md:w-full clear-both float-left m-[25px_0]
              after:table after:clear-both
              `}
                    >
                        <h2
                            className={`xl:text-3xl md:text-[26px] md:leading-[32px] md:mb-[24px] text-center float-left w-full
              clear-both futura-heavy m-[0_auto_30px]
              `}
                        >
                            Strategic Location at the Heart of Nepal’s Silicon Valley
                        </h2>
                        <ul
                            className={`
                                grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8
                                w-full clear-both p-0 m-[-42px_0_0] [list-style:none]
                                xl:mt-[-32px]
                            `}
                        >
                            {siliconValleyHighlights.map((highlight, idx) => {
                                return (
                                    <li
                                        className={`
                                            border-t border-t-black pt-5 xl:pt-[15px] md:pt-[14px]
                                            relative p-0
                                        `}
                                        key={idx}
                                    >
                                        <span
                                            className={`block text-center futura-heavy
                                                text-[24px] leading-[30px] text-[#272727] m-[0_0_8px]
                                                md:text-[36px] md:leading-[45px] md:mb-[14px]
                                                xl:text-[44px] xl:leading-[55px] xl:mb-[12px]
                                                [word-wrap:break-word;]
                                            `}
                                        >
                                            {highlight.value}
                                        </span>
                                        <p
                                            className={`mb-0 mt-0 text-center futura-heavy text-[14px] leading-[22px] xl:text-[14px] [word-wrap:break-word;]`}
                                        >
                                            {highlight.title}
                                        </p>
                                    </li>
                                );
                            })}
                        </ul>
                    </section> */}
                    <div
                        className={cn(
                            `
    relative w-full overflow-hidden clear-both
    min-h-[21.125rem] xl:min-h-[25.875rem]
    mb-[1.5625rem] md:mb-[2.5rem] xl:mb-[5rem] md:py-0 py-6

    z-[1] flex items-center justify-center
    `,
                            `
    supports-[width:100vw]:left-1/2
    supports-[width:100vw]:right-1/2
    supports-[width:100vw]:mx-[-50vw]
    supports-[width:100vw]:w-[100vw]
    `
                        )}
                    >
                        {/* BACKGROUND LAYERS */}
                        <div className="absolute inset-0 pointer-events-none z-0">
                            {/* Gradient */}
                            <div
                                className="
        absolute inset-0
        before:absolute before:inset-0
        before:bg-[linear-gradient(to_right,#000000,#750102,#000000)]
      "
                            />

                            {/* Pattern */}
                            <div
                                className="
        absolute inset-0
        after:absolute after:inset-0
        after:bg-[url('/data_icon/charlie-brown-05.png')]
        after:[background-size:0.625rem]
        after:opacity-20
      "
                            />
                        </div>

                        {/* CONTENT */}
                        <div className="relative z-10 flex flex-col items-center justify-center h-full text-white">
                            <h2
                                className="
        font-bold text-center
        text-[1.5rem] leading-[1.875rem]
        md:text-[2.25rem] md:leading-[2.8125rem]
        xl:text-[2.75rem] xl:leading-[3.4375rem]
        max-w-[57.875rem]
        mb-[2.625rem]
      "
                            >
                                Strategic Location at the Heart of Nepal’s Silicon Valley
                            </h2>

                            <ul
                                className="
        grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3
        gap-x-6 gap-y-8
        w-full max-w-[57.875rem]
        [list-style:none]
      "
                            >
                                {siliconValleyHighlights.map((highlight, idx) => (
                                    <li
                                        key={idx}
                                        className="border-t border-white pt-5 text-center"
                                    >
                                        <span
                                            className="
              block font-bold
              text-[24px] leading-[30px]
              md:text-[36px] md:leading-[45px]
              xl:text-[44px] xl:leading-[55px]
              mb-2
            "
                                        >
                                            {highlight.value}
                                        </span>

                                        <p className="text-[14px] leading-[22px]">
                                            {highlight.title}
                                        </p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>


                    <section
                        id="upstart"
                        className={`p-0 xl:mb-[4.3125rem] md:mb-[3.75rem] w-full max-w-[90rem] m-[0_auto] 
              clear-both block md:scroll-mt-48 scroll-mt-20
              `}
                    >
                        <h2
                            className={cn(
                                `xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] md:mx-auto md:w-full
               [word-wrap:break-word;]
               xl:text-[1.75rem] xl:leading-[2.5rem] md:mb-4 md:clear-none 
               font-bold mt-0 mb-[0.375rem] text-[1.25rem] leading-[1.6875rem]`
                            )}
                        // className="font-bold text-[1.75rem] md:text-[2.25rem] m-0 text-center"

                        >
                            Pcps Upstart &nbsp;
                        </h2>
                        {/*  <p
                            className={`xl:box-content xl:mb-[1.5rem] md:px-[3.625rem] md:max-w-[43.125rem] 
              md:mx-auto md:w-full [word-wrap:break-word;]
              md:text-base xl:leading-[2rem] md:mb-[1.9375rem]
               mt-0 mb-[1.75rem] text-[0.875rem] leading-[1.75rem]`}
                        >
                            PCPS Upstart is Nepal’s biggest college seed funding event, exclusively designed for PCPS College students. With 1 crore NPR in seed funding up for grabs, the initiative empowers young innovators to turn their ideas into real businesses. Beyond financial support, participants gain access to mentorship from industry experts, networking opportunities with investors, and guidance to scale their ventures. PCPS Upstart not only fuels entrepreneurship on campus but also fosters a culture of creativity, problem-solving, and practical learning, giving students the tools and resources to make a meaningful impact locally and globally
                        </p> */}

                        <aside className={cn(
                            `xl:float-none xl:m-[2.5rem_auto_5rem] xl:max-w-[59.875rem]`,
                            // `md:m-[1.875rem_0] md:max-w-[38.125rem] max-w-full`,
                            `md:m-[1.875rem_0]  max-w-full`,

                            `clear-both float-left m-[1.5625rem_0] pb-[3.75rem] relative w-full`,
                            `xl:before:top-[1.875rem] xl:before:top-[1.875rem] xl:before:w-[9rem]`
                            ,
                            `md:before:top-[1.875rem] md:before:w-[8.9375rem] before:bg-[url('/data_icon/text_highlight--bg.png')] 
                            before:bg-repeat before:bottom-0 before:left-0
                            before:absolute before:top-[1.3125rem] before:w-[5.75rem] before:z-0
                            `
                        )}>
                            <div className={cn(
                                `xl:h-[6.5625rem] xl:left-[2.375rem] xl:w-[6.625rem] `,
                                `md:h-[6.5625rem] md:left-[2.375rem] md:w-[6.5625rem]`,
                                `h-[4.5625rem] left-[1.1875rem] absolute top-0 w-[4.5625rem] z-0`,
                                `xl:before:w-[6.625rem] md:before:w-[6.5625rem] before:bg-[#0F3F82] before:h-[0.625rem] before:absolute before:w-[4.5625rem]`,
                                `xl:after:h-[6.5625rem] md:after:h-[6.5625rem] after:bg-[#0F3F82] after:h-[4.5625rem] after:absolute
                                after:w-[0.625rem]
                                `
                            )} />
                            <div className={cn(
                                `xl:p-[1.875rem_0_0_5.5625rem] md:max-w-none md:p-[1.875rem_0_0_5.3125rem]`,
                                `p-[1.3125rem_0_0_2.9375rem] relative z-0 `,
                                `flex md:flex-row flex-col justify-center`
                            )}>
                                <Image
                                    alt="upstart"
                                    src={"/upstart.jpg"}
                                    width={192}
                                    height={240}
                                    className={cn(
                                        `object-cover md:float-right w-48 h-full mr-6`
                                    )}
                                />
                                <p className={cn(
                                    // `xl:text-[1.625rem] xl:leading-[2.625rem] xl:m-[1.875rem_0_1rem]`,

                                    // `md:text-[1.3125rem] md:leading-[2.125rem] md:m-[0.9375rem_0_0.75rem]`,
                                    `md:text-base md:m-[0.9375rem_0_0.75rem]`,
                                    `text-[1.125rem] leading-[1.8125rem] m-[1.3125rem_0_0.25rem] relative z-[1]`
                                )}>
                                    <strong>PCPS Upstart is Nepal’s biggest college seed funding event</strong>,  exclusively designed for PCPS College students. With NPR 1 crore in seed funding available, the programme empowers young innovators to transform their ideas into real businesses. Beyond financial support, participants gain access to mentorship from industry experts, networking opportunities with investors, and strategic guidance to scale their ventures. PCPS Upstart not only fuels entrepreneurship on campus but also fosters a culture of creativity, problem-solving, and practical learning equipping students with the tools and resources to create meaningful impact both locally and globally.
                                </p>

                            </div>

                        </aside>

                    </section>

                    {/* <HowToSeries /> */}

                    <WordsFormOurLeaders />

                    {/*    <section
                        className={`xl:mt-[7.0625rem] md:mt-[5.8125rem] mt-[3.9375rem] `}
                    >
                        <div
                            className={`p-0 xl:mb-[4.3125rem] md:mb-[3.75rem] w-full max-w-[90rem] m-[0_auto]
                clear-both mb-[2rem] block`}
                        >
                            <h2
                                className={`xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] md:mx-auto md:w-full
                  [word-wrap:break-word;]
                  xl:text-[1.875rem] xl:leading-[2.5rem] md:mb-4 md:clear-none 
                  futura-heavy mt-0 mb-[0.375rem] text-[1.25rem] leading-[1.6875rem]`}
                            >
                                Words from our leaders
                            </h2>
                            <figure
                                className={`xl:m-[0.5625rem_1.875rem_2.5rem_3.9375rem] xl:max-w-[20.625rem] md:float-left 
                  md:m-[1.5625rem_2rem_1.9375rem_0] md:max-w-[16.75rem] table m-[1.5625rem_0] relative w-full 
                  clear-left`}
                            >
                                <div
                                    className={`bg-[url('/img/leaders/pankaj_jalan.jpeg')] size-[20.625rem] 
                    xl:max-h-[20.625rem] md:max-h-[16.75rem] bg-no-repeat bg-contain h-[87.5vw] 
                    max-h-[25rem] w-full`}
                                />
                            </figure>
                            <p
                                className={`xl:box-content md:px-[3.625rem] md:max-w-[43.125rem]
                  md:mx-auto md:w-full [word-wrap:break-word] 
                  xl:pt-[0.0625rem] md:clear-none clear-both
                  xl:mb-[1.5rem] md:mb-[1.9375rem] md:text-base md:leading-[2rem]
                   mt-0 mb-[1.75rem]`}
                            >
                                <strong className="font-bold">Er. Pankaj Jalan</strong>
                                <br />
                                We believe that acquiring the certificate is not enough on
                                today's date, expertise is also a must for the self-marketing of
                                the students in the global arena. With this vision, we strive to
                                provide our youth with the best preparation for careers and life
                                after graduation. We strongly believe in the adage, "Education
                                is for life, not just for a living," and we strive to instill in
                                our students a love of learning that will include the knowledge
                                and understanding they will need to make a positive contribution
                                to the communities in which they live and work.
                            </p>
                        </div>

                        <div
                            className={`p-0 xl:mb-[4.3125rem] md:mb-[3.75rem] w-full max-w-[90rem] m-[0_auto]
                clear-both mb-[2rem] block flex flex-col md:flex-row-reverse md:items-start`}
                        >
                            <figure
                                className={`xl:m-[0.5625rem_3.9375rem_2.5rem_1.875rem] xl:max-w-[20.625rem] md:float-right 
                  md:m-[1.5625rem_0_1.9375rem_2rem] md:max-w-[16.75rem] table m-[1.5625rem_0] relative w-full 
                  clear-right`}
                            >
                                <div
                                    className={`bg-[url('/img/leaders/prakash_kumar_kejriwal.jpeg')] size-[20.625rem] 
                    xl:max-h-[20.625rem] md:max-h-[16.75rem] bg-no-repeat bg-contain h-[87.5vw] 
                    max-h-[25rem] w-full `}
                                />
                            </figure>
                            <div
                                className={`flex-1 xl:box-content md:px-[3.625rem] md:max-w-[43.125rem] 
                  md:mx-auto md:w-full [word-wrap:break-word] xl:pt-[0.0625rem] md:clear-none clear-both
                  xl:mb-[1.5rem] md:mb-[1.9375rem] md:text-base md:leading-[2rem]
                  mt-0 mb-[1.75rem]`}
                            >
                                <strong className="font-bold">
                                    Er. Prakash Kumar Kejriwal
                                </strong>
                                <br />
                                We believe that acquiring the certificate is not enough on
                                today's date, expertise is also a must for the self-marketing of
                                the students in the global arena. With this vision, we strive to
                                provide our youth with the best preparation for careers and life
                                after graduation. We strongly believe in the adage, "Education
                                is for life, not just for a living," and we strive to instill in
                                our students a love of learning that will include the knowledge
                                and understanding they will need to make a positive contribution
                                to the communities in which they live and work.
                            </div>
                        </div>
                    </section> */}
                </div>
            </div>
        </article>
    );
}